import React from "react";

export const CodeRoundedIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="none"
  >
    <path
      d="m197.3-479.24 151.18 151.17q12.91 12.92 12.79 31.95-.12 19.03-13.03 31.95-12.91 12.91-31.83 12.79-18.91-.12-31.82-12.79l-184-183.76q-6.72-6.72-9.82-14.92-3.1-8.19-3.1-17.15 0-8.96 3.1-17.15 3.1-8.2 9.82-14.92l184-184q13.67-13.67 32.32-13.67 18.66 0 32.33 13.67 13.67 13.68 13.67 32.45 0 18.77-13.67 32.45L197.3-479.24Zm565.4-1.52L611.52-631.93q-12.91-12.92-12.79-31.95.12-19.03 13.03-31.95 12.91-12.91 31.83-12.79 18.91.12 31.82 12.79l184 183.76q6.72 6.72 9.82 14.92 3.1 8.19 3.1 17.15 0 8.96-3.1 17.15-3.1 8.2-9.82 14.92l-184 184q-13.67 13.67-31.94 13.29-18.27-.38-31.95-14.06-13.67-13.67-13.67-32.44 0-18.77 13.67-32.45L762.7-480.76Z"
      fill="black"
    />
  </svg>
);
